import Link from 'next/link';

import type { Dispatch } from 'react';

import type { ILinkData, ILinkSectionData, ISubSections } from '@/shared/actions/navigation.service';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/shared/ui/accordion';

export interface IMobileMainMenuProps {
    mainNavigation: (ILinkData | ILinkSectionData)[];
    setSubsectionSelected: Dispatch<React.SetStateAction<ISubSections | null>>;
    setAccordionOpen: Dispatch<React.SetStateAction<boolean>>;
}
export function MobileMainMenu({ mainNavigation, setSubsectionSelected, setAccordionOpen }: IMobileMainMenuProps) {
    return (
        <div className='flex w-full flex-col items-center justify-center gap-6'>
            <Accordion
                type='single'
                collapsible
                onValueChange={value => {
                    setAccordionOpen(!!value);
                }}
                className='flex w-full flex-col items-center justify-center'>
                {mainNavigation?.map(menu => (
                    <div key={`MenuItem-${menu.id}`} className='w-full py-3 text-center'>
                        {'isLinkSection' in menu ? (
                            (() => {
                                if (menu.isDestination) {
                                    return (
                                        <AccordionItem value={menu.title || ''} className='border-none'>
                                            <AccordionTrigger className='text-center'>
                                                <div className='text-menu-primary text-spot w-full cursor-pointer'>
                                                    {menu.title}
                                                </div>
                                            </AccordionTrigger>

                                            <AccordionContent>
                                                <div className='flex flex-col items-center gap-6 pt-10'>
                                                    {menu.subSections &&
                                                        menu.subSections.map(subSection => {
                                                            if (!subSection.title) return null;
                                                            return (
                                                                <button
                                                                    key={`Trigger-${subSection.id}`}
                                                                    onClick={() => setSubsectionSelected(subSection)}
                                                                    className='text-menu-category w-full cursor-pointer py-3 text-center'>
                                                                    {`${subSection.title} (${subSection.links?.length})`}
                                                                </button>
                                                            );
                                                        })}
                                                </div>
                                            </AccordionContent>
                                        </AccordionItem>
                                    );
                                }
                                return (
                                    <button
                                        className='text-menu-primary text-spot w-full cursor-pointer'
                                        onClick={() => setSubsectionSelected(menu)}>
                                        {menu.title}
                                    </button>
                                );
                            })()
                        ) : (
                            <Link
                                href={menu.internalLink || menu.url || '#'}
                                className='text-menu-primary text-spot w-full cursor-pointer'>
                                {menu.title}
                            </Link>
                        )}
                    </div>
                ))}
            </Accordion>
        </div>
    );
}
